export default __webpack_public_path__ + "static/Partners_logo-3d6f363a4f68f3ab451c69614e8e419a.svg";